/**
 * @packageDocumentation
 * @module Datetime
 */
import { format } from 'date-fns-tz';
import getZonedDateFromDateString from './getZonedDateFromDateString';
/**
 * Function to get a date string for a given date string, timezone and format
 * @param dateTimeString: string with the date to convert
 * @param timezone: Timezone for the conversion
 * @param dateFormat: string with the format to analyze
 *
 * @return string
 */
var getZonedDateStringFromDateString = function (dateTimeString, timezone, dateFormat) { return format(getZonedDateFromDateString(dateTimeString, timezone), dateFormat, { timeZone: timezone }); };
export default getZonedDateStringFromDateString;
//# sourceMappingURL=getZonedDateStringFromDateString.js.map